import { call, put, takeEvery } from 'redux-saga/effects';
import { deleteLeadProfilePhotos } from '../../requests/delete_lead_profile_photos_request';
import { deleteLeadProfileRequestSuccess, deleteLeadProfileRequestFailure } from '../actions/lead_profile_photos.actions';
import { DELETE_LEAD_PROFILE_PHOTO_REQUEST } from '../constants/lead_profile_photos.constants';
import { message_error } from '../../../../../components/Message';

function* deleteLeadProfilePhotosSagaRequest({ _id, photos, photo_index }) {
    const {
        result, msg, options, error,
    } = yield call(deleteLeadProfilePhotos, _id, photos, photo_index);

    if (result) {
        yield put(deleteLeadProfileRequestSuccess(photos));
    } else {
        yield put(deleteLeadProfileRequestFailure(error));
        message_error(msg);
    }
}

export default function* deleteLeadProfilePhotosSaga() {
    yield takeEvery(DELETE_LEAD_PROFILE_PHOTO_REQUEST, deleteLeadProfilePhotosSagaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/delete_lead_profile_photos.saga.js